import { useMemo } from 'react'
import { useSuspenseQuery } from '@apollo/client'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'
import { useParams } from 'wouter'
import { useLingui } from '@lingui/react/macro'

import { Suspense } from '@/components/ui/Suspense'
import { DialogHeader } from '@/layouts/Dialog'
import { StayForm } from '@/features/stay'
import { useCloseModal } from '@/Router'

export function Stay({ token }: { token: string }) {
  const { t } = useLingui()

  const isCheckOut = history.state.isCheckOut
  const isCheckIn = history.state.isCheckIn

  const closeModal = useCloseModal()

  const { data } = useSuspenseQuery(AdminAPI.stay.GET_BY_TOKEN, {
    variables: { token },
    fetchPolicy: 'cache-and-network'
  })

  const stay = useMemo(() => {
    if (!data) return

    return getFragment(SharedAPI.stay.STAY_FRAGMENT, data.getStayByToken)
  }, [data])

  if (!stay) return null

  return (
    <div className="flex flex-col gap-7 p-5">
      <DialogHeader
        title={t`Guest Stay`}
        description={t({
          comment: 'Description of the Stay dialog',
          message: `Show or Edit the details of a guest stay`
        })}
      />
      <StayForm
        id={stay.id}
        isCheckIn={!!isCheckIn}
        isCheckOut={!!isCheckOut}
        onCancel={closeModal}
        onDone={closeModal}
      />
    </div>
  )
}

export default function StaySuspense() {
  const params = useParams() as { token: string }

  if (!params) return null

  return (
    <Suspense isDialog>
      <Stay token={params.token} />
    </Suspense>
  )
}
